import * as React from 'react'
import { connect } from 'react-redux'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { configFloatingLabelInputsSelector } from 'embed/selectors/config'
import { FieldTooltip } from 'embed/components/ApplicationField/FieldTooltip'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

const styles = require('embed/styles/application')

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  useFloatingLabelInputs?: boolean
}

export const StepbystepApplicationStepCoApplicantToggle: React.FunctionComponent<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>
      Are you applying with a co-applicant?
      {props.useFloatingLabelInputs && (
        <>
          {' '}
          <FieldTooltip
            className={styles.questionTooltip}
            field={Fields.ApplyWithCoApplicantButtonList}
            useFloatingLabelInputs={true}
            shouldShowIsInvalid={false}
          />
        </>
      )}
    </StepTitle>
    <ApplicationField
      onChange={props.handleChangeAndContinue.bind(null, Fields.ApplyWithCoApplicantButtonList)}
      product={Product.Loan}
      field={Fields.ApplyWithCoApplicantButtonList}
    />
  </Wrapper>
)

const mapStateToProps = (state) => ({
  useFloatingLabelInputs: configFloatingLabelInputsSelector(state),
})

export default connect(mapStateToProps)(StepbystepApplicationStepCoApplicantToggle)
